// extracted by mini-css-extract-plugin
module.exports =  {"license":"ZrsVHfd6qH_Zdbp5X8F4","maxBudget":"KwIuR0YlRFZxxPX83uCq"};